import { useState } from "react";

function chaveArquivoPrescricao(arquivo) {
  return `${arquivo.name}-${arquivo.size}-${arquivo.lastModified}`;
}

export default function useArquivosPrescricao() {
  const [arquivosPrescricao, setArquivosPrescricao] = useState([]);

  const handleSelecionarArquivosPrescricao = (event) => {
    const arquivosSelecionados = Array.from(event.target.files || []);

    setArquivosPrescricao((arquivosAtuais) => {
      const chavesArquivosAtuais = new Set(
        arquivosAtuais.map(chaveArquivoPrescricao)
      );
      const novosArquivos = arquivosSelecionados.filter(
        (arquivo) => !chavesArquivosAtuais.has(chaveArquivoPrescricao(arquivo))
      );

      return [...arquivosAtuais, ...novosArquivos];
    });

    event.target.value = "";
  };

  const handleRemoverArquivoPrescricao = (arquivoRemover) => {
    setArquivosPrescricao((arquivosAtuais) =>
      arquivosAtuais.filter(
        (arquivo) =>
          chaveArquivoPrescricao(arquivo) !== chaveArquivoPrescricao(arquivoRemover)
      )
    );
  };

  return {
    arquivosPrescricao,
    setArquivosPrescricao,
    handleSelecionarArquivosPrescricao,
    handleRemoverArquivoPrescricao,
  };
}
